var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},_vm._l((_vm.sloganList),function(item){return _c('div',{key:item.id,staticClass:"item"},[_c('div',{staticClass:"tit"},[_vm._v(_vm._s(item.titEn))]),_c('div',{staticClass:"des"},[_vm._v(_vm._s(item.introEn))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }